






































import { Component, Vue } from 'vue-property-decorator'
import { OptionModel } from '@/models/global'

@Component({
})
export default class Header extends Vue {
  languages: OptionModel[] = [
    { text: 'Deutsch', value: 'de' },
    { text: 'English', value: 'en' },
    { text: 'Italiano', value: 'it-CH' },
    { text: 'Français', value: 'fr' }
  ];

  get selectedLang () {
    const lng = this.$store.getters.language
    return this.languages.find(item => item.value === lng)?.text || 'English'
  }

  setLanguage (lang: OptionModel) {
    this.$store.commit('setLanguage', lang.value)
  }
}
